export default __webpack_public_path__ + "static/go-to-1839849ed349f4f09a58b694243a4db8.svg";